export interface UpdateAddressRequest {
    /** The address street line 1. */
    streetLine1: string;
    /** The address street line 2. */
    streetLine2: string;
    /** The address postal code. */
    postalCode: string;
    /** The address city name. */
    cityName: string;
}

/**
 * The Organization resource.
 *
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client) {
    return {
        /**
         * Update an organization address.
         *
         * @param {number} organizationAddressId - The address id to update.
         * @param {Address} organizationAddress - The organization address.
         *
         * @return {Promise<any>}
         */
        async updateAddress(organizationAddressId: number, organizationAddress: UpdateAddressRequest): Promise<any> {
            return client.put(`/organizations/addresses/${organizationAddressId}`, organizationAddress)
                .then(response => response.data.data);
        }
    };
}
